import { computed, Directive, effect, ElementRef, input } from '@angular/core';

const RTL_LANGUAGE_PREFIXES = ['ar', 'he', 'fa', 'ps', 'ur'];

@Directive({
  selector: '[appTextDirection]',
  standalone: true
})
export class TextDirectionDirective {
  readonly appTextDirection = input<string | null | undefined>();

  private readonly isRtl = computed(() => {
    const language = this.appTextDirection();
    if (!language) return false;
    const prefix = language.split('-')[0].toLowerCase();
    return RTL_LANGUAGE_PREFIXES.includes(prefix);
  });

  constructor(private el: ElementRef<HTMLElement>) {
    effect(() => {
      const isRtl = this.isRtl();
      const language = this.appTextDirection();
      this.applyDirection(isRtl);
    });
  }

  private applyDirection(isRtl: boolean): void {
    const element = this.el.nativeElement;

    element.dir = isRtl ? 'rtl' : 'ltr';
    element.style.textAlign = isRtl ? 'right' : 'left';

    const computedStyle = getComputedStyle(element);
    if (computedStyle.display === 'flex' || computedStyle.display === 'inline-flex') {
      element.style.alignItems = isRtl ? 'flex-end' : 'flex-start';
    }
  }
}
